import { createAsyncThunk }             from '@reduxjs/toolkit';
import { initData,sendPost,getRslt }    from './init.js';

// ADD/UPDATE
export const addUpdate = createAsyncThunk('addUpdate',async(sendData)=>{
	let initInfo = {};
	initData(null,function(initRslt){
		initInfo = initRslt;
	});
	let rslt = [];
	if(sendData.formData){
		let proData       = initInfo.proData;
		proData.url       = sendData.sendTo+'/addUpdate';
		proData.formData  = sendData.formData;
		await sendPost(proData,async function(postRslt){
			rslt =  postRslt;
		});
	}else{
		initInfo.frm = 'invalid_formdata';
		await getRslt(initInfo,function(postRslt){
			rslt =  postRslt;
		});
	}
	return rslt;
});

//GET COMMON DROP 
export const getCommonDrop = createAsyncThunk('commonDropDown',async(sendData)=>{
	let initInfo = {};
	initData(null,function(initRslt){
		initInfo = initRslt;
	});
	let rslt = [];
	if(sendData){
		let proData       = initInfo.proData;
		proData.url       = sendData.sendTo+'/get_common_drop';
		await sendPost(proData,async function(postRslt){
			rslt =  postRslt;
		});
	}else{
		initInfo.frm = 'invalid_formdata';
		await getRslt(initInfo,function(postRslt){
			rslt =  postRslt;
		});
	}
	return rslt;
});

//GET COMMON DROP 
export const careerAddUpdate = createAsyncThunk('careerAddUpdate',async(sendData)=>{
	let initInfo = {};
	initData(null,function(initRslt){
		initInfo = initRslt;
	});
	let rslt = [];
	if(sendData){
		let proData       = initInfo.proData;
		proData.url       = sendData.sendTo+'/career_addUpdate';
		proData.formData = sendData.formData;
		await sendPost(proData,async function(postRslt){
			rslt =  postRslt;
		});
	}else{
		initInfo.frm = 'invalid_formdata';
		await getRslt(initInfo,function(postRslt){
			rslt =  postRslt;
		});
	}
	return rslt;
});
